import React, { useContext } from 'react';
import { TeApiContext } from '@ecommerce/nest-ssr/common';
import Image from 'atomic/image';

import './product-action-producer.scss';
import Link from 'atomic/utilization/link';

interface ProducerProps {
    name: string;
    src: string;
    url: string;
}

const ProductActionProducer: React.FC<ProducerProps> = props => {
    const api = useContext(TeApiContext);

    if (api === null) {
        throw new Error('Invalid API context');
    }

    return (
        <div className={`product-action-producer ${api.getDevice()}`}>
            <Link href={props.url}>
                <Image src={props.src} alt={props.name} width={70}
                    height={70} show={true}
                />
                <div className="text">
                    <span>
                        Strefa producenta
                    </span>
                    <div className="icon">
                        <i className="icon-arr1-right"/>
                    </div>
                </div>
            </Link>
        </div>
    );
};

export default ProductActionProducer;
